import React from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
// Components
import ChangeStatusBtn from './ChangeStatusBtn';
import CutoffTimer from './CutoffTimer';
import StarIcon from 'assets/images/svg/StarIcon';
import RightCaret from 'assets/images/svg/RightCaret';
import FlashIcon from 'assets/images/svg/FlashIcon';
import ListIcon from 'assets/images/svg/ListIcon';
// Helpers
import { colleagueStatus, preparationTypes } from 'constants/Helpers';
import { NOT_DONE_STATES, ASSIGNMENT_SOURCES } from 'constants/OrdersFilters';

const WRAP_SERVICE_TYPE = 1;

const getStatusLabel = (item) => colleagueStatus[item?.preparationStatus] || 'Not Assigned';

const getOrderTags = (item, isMyTasks) => {
  const tags = [];
  // expressDelivery is the flag on the orders DTO; orderPriority is the legacy one.
  if (item?.expressDelivery || item?.orderPriority === 1) {
    tags.push({ label: 'Express', className: 'express', icon: <FlashIcon cssClass="tag-icon" /> });
  }
  // My Tasks flags the florist's own orders that are past their cut-off, and says
  // how each one reached them.
  if (isMyTasks && item?.isOverdue) {
    tags.push({ label: 'Overdue', className: 'overdue' });
  }
  if (isMyTasks && ASSIGNMENT_SOURCES[item?.assignmentSource]) {
    tags.push({ label: ASSIGNMENT_SOURCES[item.assignmentSource], className: 'source' });
  }
  // A florist dropped it and it is waiting for someone to pick it up.
  if (item?.notDoneState === NOT_DONE_STATES.AWAITING_REASSIGNMENT) {
    tags.push({ label: 'Dropped Order', className: 'dropped' });
  }
  if (item?.membershipType === 1) {
    tags.push({ label: 'VIP', className: 'vip' });
  }
  if (item?.isNwDelivery) {
    tags.push({ label: 'NW', className: 'nw' });
  }
  if (item?.partnerName) {
    tags.push({ label: item.partnerName, className: 'partner' });
  }
  return tags;
};

const RankedOrderCard = ({ item, initialParams, fetchMoreData, isMyTasks }) => {
  const navigate = useNavigate();
  const prepTasks = item?.cartData?.filter((cart) => cart?.serviceType !== WRAP_SERVICE_TYPE) ?? [];
  const prepType = preparationTypes.find(
    (pt) => parseInt(pt.id, 10) === parseInt(item?.preparationType, 10)
  );
  const timeSlot = item?.deliveryTimeName
    ? `${item.deliveryTimeName}${item?.nickName ? ` (${item.nickName.toUpperCase()})` : ''}`
    : '-';

  return (
    <div className="card ranked-order-card">
      <div className="ranked-order-main">
        {prepTasks?.[0]?.productImageFullPath && (
          <img
            className="ranked-order-img"
            alt="product"
            src={prepTasks[0].productImageFullPath}
            onClick={() => navigate(`/orderdetails/${item?.id}`)}
          />
        )}

        <div className="ranked-order-content">
          <div className="ranked-order-head">
            {item?.rank != null && (
              <span
                className="rank-badge"
                title={
                  item?.fulfillmentTimeDisplay
                    ? `Fulfillment time: ${item.fulfillmentTimeDisplay}`
                    : undefined
                }
              >
                {item.rank}
              </span>
            )}
            <h6 className="ranked-order-id" onClick={() => navigate(`/orderdetails/${item?.id}`)}>
              #{item?.id}
            </h6>
            {item?.productionLine === 1 && <StarIcon cssClass="star-icon" />}
            {getOrderTags(item, isMyTasks).map((tag) => (
              <span key={tag.label} className={`order-tag ${tag.className}`}>
                {tag.icon}
                {tag.label}
              </span>
            ))}
            <span className={`status-badge status-${item?.preparationStatus ?? 'none'}`}>
              {getStatusLabel(item)}
            </span>
            {prepType && (
              <span
                className="prep-type-tag"
                style={{ backgroundColor: prepType.bgColor, color: prepType.textColor }}
              >
                {prepType.name}
              </span>
            )}
            <div className="ranked-order-head-right">
              <CutoffTimer item={item} />
            </div>
          </div>

          <div className="ranked-order-details">
            <div className="detail-col">
              <span className="detail-label">Florist</span>
              <span className="detail-value florist-value">
                {item?.floristDto?.name || '-'}
                {item?.opsName && <span className="ops-tag">{item.opsName}</span>}
              </span>
            </div>
            <div className="detail-col">
              <span className="detail-label">Tasks to prep</span>
              <span className="detail-value">{prepTasks.length}</span>
            </div>
            <div className="detail-col">
              <span className="detail-label">Delivery date</span>
              <span className="detail-value">
                {item?.deliveryDate ? moment(item.deliveryDate).format('MMM DD, YYYY') : '-'}
              </span>
            </div>
            <div className="detail-col">
              <span className="detail-label">Time slot</span>
              <span className="detail-value">{timeSlot}</span>
            </div>
            <div className="detail-col actions-col">
              <ChangeStatusBtn
                item={item}
                fetchMoreData={fetchMoreData}
                initialParams={initialParams}
                details={false}
                showAllCTA={true}
              />
              <button
                type="button"
                className="view-details-btn"
                onClick={() => navigate(`/orderdetails/${item?.id}`)}
              >
                <ListIcon cssClass="view-details-icon" />
                View details
                <RightCaret />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RankedOrderCard;
